<style lang="scss">
.error-overlay {
    position: fixed;
    z-index: 10;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .bg {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255, 0.5);
        backdrop-filter: blur(10px);
    }
}

.error-popup {
    background: #fff;
    border-radius: 10px;
    padding: 10px;
    box-shadow: 3px 3px 10px rgba(0,0,0,0.2);
    width: 400px;
    position: relative;
    z-index: 2;
}

.close {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 20px;
    transform: rotate(45deg);
    cursor: pointer;
    font-family: arial, sans-serif;
    display: block;
    line-height: 1em;
    width: 1em;
    text-align: center;
}

.content {
    color: red;
    white-space: pre;
    overflow: auto;
    max-height: 300px;
}
</style>
<script lang="ts">
import { createEventDispatcher } from 'svelte';
import { fade, scale } from 'svelte/transition';
import { cubicOut } from 'svelte/easing';

export let error: Error | string;
const dispatch = createEventDispatcher();
</script>

<div class="error-overlay">
    <div class="bg" transition:fade={{duration: 300, easing: cubicOut}}></div>
    <div class="wrap" transition:scale={{duration: 300, easing: cubicOut}}>
        <div class="error-popup">
            <i class="close" on:click={() => dispatch('close')} >+</i>
            <div class="content">
                {error.toString()}
            </div>
        </div>
    </div>
</div>
